<!--  -->
<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <ScreenBoxClick title="设施告警概览" height="33.3%" menuCode="030201">
        <PlantAlarmStatics></PlantAlarmStatics>
      </ScreenBoxClick>
      <screen-box title="设施告警类型统计" height="33.3%">
        <PlantAlarmTypeStatics> </PlantAlarmTypeStatics>
        <!-- <TodayUseWater style="margin-top: 10px; height: 35%"> </TodayUseWater> -->
      </screen-box>
      <screen-box title="设施告警工单统计" height="33.3%">
        <AlarmWorkorder></AlarmWorkorder>
      </screen-box>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <ScreenBoxClick title="设施工单概览" height="50%" menuCode="030203">
        <WorkorderOverview style="margin-top: 10px"></WorkorderOverview>
      </ScreenBoxClick>
      <screen-box title="设施告警等级统计" height="50%">
        <PlantAlarmLevelStatics> </PlantAlarmLevelStatics>
      </screen-box>
      <!-- <screen-box title="本月用水趋势" height="33.3%">
        <MonthUseWater style="margin-top: 10px"> </MonthUseWater>
      </screen-box> -->
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBox from "../components/ScreenBox.vue";
import PlantAlarmTypeStatics from "../components/PlantAlarmTypeStatics";
// import TodayUseWater from "../components/TodayUseWater";
import PlantAlarmLevelStatics from "../components/PlantAlarmLevelStatics";
// import MonthUseWater from "../components/MonthUseWater";
// import TrafficChart from "../components/TrafficChart";
import WorkorderOverview from "../components/WorkorderOverview";
import AlarmWorkorder from "../components/AlarmWorkorder";
import PlantAlarmStatics from "../components/PlantAlarmStatics";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
export default {
  data() {
    return {
      personTypeData: {},
      isOpen: false,
    };
  },
  components: {
    screenPanel,
    ScreenBox,
    PlantAlarmTypeStatics,
    // TodayUseWater,
    PlantAlarmLevelStatics,
    PlantAlarmStatics,
    // MonthUseWater,
    // DiffStoragePower,
    AlarmWorkorder,
    WorkorderOverview,
    ScreenBoxClick
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
  }
};
</script>
<style lang='scss' scoped>
.panel {
  height: 100%;
}
</style>
